import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Spectrum UXP Widgets/User Interface/sp-divider";
import * as React from 'react';
export default {
  Content,
  React
};